// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
// hooks
import useSettings from '../../../hooks/useSettings';
// universe
import Icon from '../../universe/Icon';
import { segmentSx, segmentedTrackSx } from '../../universe/Surface';
import { touchHitSx } from '../../../theme/universe/brand';

// ----------------------------------------------------------------------
// THE MODE (DESIGN.md §18, §23): Light · Dark as the segmented control —
// two views of one portal, the chosen one on paper with its glyph filled —
// the same control the vendor portal's account menu draws for the same
// choice, so the theme is chosen the same way in every portal. It was a
// sun-and-moon toggle switch: a switch says on or off, and dark is not "on".

const MODES = [
  { mode: 'light', label: 'Light', icon: 'Sun1' },
  { mode: 'dark', label: 'Dark', icon: 'Moon' }
];

export default function SettingMode() {
  const theme = useTheme();
  const { themeMode, onChangeMode } = useSettings();

  return (
    <Box
      role="radiogroup"
      aria-labelledby="settings-mode-label"
      sx={{
        ...segmentedTrackSx(theme),
        display: 'flex',
        flexWrap: 'nowrap',
        width: 1
      }}
    >
      {MODES.map((option) => {
        const on = themeMode === option.mode;
        return (
          <Box
            key={option.mode}
            component="button"
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => {
              if (!on) onChangeMode({ target: { value: option.mode } });
            }}
            sx={{
              ...segmentSx(theme, on),
              flex: 1,
              height: 32,
              justifyContent: 'center',
              fontSize: 13,
              ...(on && { cursor: 'default' }),
              '@media (pointer: coarse)': touchHitSx
            }}
          >
            <Icon
              name={option.icon}
              size="sm"
              variant={on ? 'Bold' : 'Linear'}
            />
            {option.label}
          </Box>
        );
      })}
    </Box>
  );
}
